const observeBadgeText = () => {
    const observer = new MutationObserver((mutationsList) => {
      for (const mutation of mutationsList) {
        if (mutation.type === 'childList') {
          const badgeTextElement = document.querySelector('.jdgm-preview-badge.jdgm-preview-badge--with-link.jdgm--done-setup .jdgm-prev-badge__text');
  
          if (badgeTextElement) {
            setTimeout(() => {
              const text = badgeTextElement.textContent.trim();
              const targetElement = document.querySelector('.main-product__reviews .jdgm-prev-badge__text');
  
              if (targetElement) {
                targetElement.textContent = text;
              }
              const parentBadge = badgeTextElement.closest('.jdgm-preview-badge.jdgm-preview-badge--with-link.jdgm--done-setup');
              if (parentBadge) {
                parentBadge.remove();
              }
              observer.disconnect();
            }, 1); 
          }
        }
      }
    });
  
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  };
  
  observeBadgeText();

  